<template>
  <div >
    <div class="d-flex justify-content-center flex-column flex-md-row justify-content-md-start align-items-md-center" style="padding-bottom: inherit;min-heigth:30px;">

      <!-- Header title -->
      <h4 v-if="showTitle">{{$t('users.activities.title')}}</h4>

      <!-- Filter buttons -->
      <div class="d-flex justify-content-end search-text-wrapper pt-3 align-items-center" style="margin-left: auto;">
        <div class="d-flex align-self-center align-items-center">
          <searchable
            :querySearch.sync="querySearch"
            :placeholder="this.$t(`users.activities.${activeComponent.searchPlaceholder}`)"
            :searchTooltip="searchTooltip"
          >
          </searchable>
            &nbsp;
          <va-popover
            :message="toogleViewsTooltip"
            placement="left">
            <span href="#" class="switch-view-icon clickable" @click.prevent="toogleView(activeComponent.id)">
              <i style="font-size: 1.3rem;" class="fa fa-exchange" :class="{'animated': animated}"></i>
            </span>
          </va-popover>
        </div>
      </div>

    </div>

    <!-- Component Content -->
    <div>
      <div v-if="isFetchingServer">
        <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>
      <div v-else>
        <div v-if="activeComponent.component">
          <transition mode="out-in">
            <component
              v-if="!error"
              :is="activeComponent.component"
              :activities="userActivities"
              :availableActivities="availableActivities"
              :query="querySearch"
              :editable="editable && activeComponent.id === 2"
              :limitItems="limitItems !== null ? limitItems : limitItemsByScreenSize"
              :clusters="clusters"
              @update-user-activities="updateUserActivities"
              @show-entities-for-activity-modal="showEntitiesForActivityModal">
            </component>
            <div v-else>
              <span class="d-flex justify-content-center pt-4">
                <b>{{ 'users.roles.' + Object.keys(error)[0] | translate }}</b>
              </span>
            </div>
          </transition>
        </div>
        <div v-else>
          <span class="d-flex justify-content-center pt-4">
            <b>{{ 'users.roles.without' | translate }}</b>
          </span>
        </div>
      </div>

      <div v-show="showLoadingIndicator">
        <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import LoadingAnimation from '../Helpers/LoadingAnimation'
import ViewActivitiesByEntity from './components/ViewActivitiesByEntity'
import ViewEntitiesByActivity from './components/ViewEntitiesByActivity'
import ScreenSizeMixin from '../Helpers/ScreenSizeMixin'
import Multiselect from 'vue-multiselect'
import Searchable from '@/components/common/Searchable'
import { mapGetters } from 'vuex'
const authenticationServerClustersEndpoint = '/clusters'
const workActivitiesEndpoint = '/workactivities'

export default {
  components: {
    LoadingAnimation,
    ViewActivitiesByEntity,
    ViewEntitiesByActivity,
    Multiselect,
    Searchable
  },
  mixins: [
    ScreenSizeMixin
  ],
  props: {
    userDetails: {
      type: Object,
      required: true
    },
    activities: {
      type: Array,
      required: true
    },
    availableActivities: {
      type: Array,
      required: false,
      default: () => []
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    limitItems: {
      type: Number,
      required: false
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isFetchingServer: true,
      showLoadingIndicator: false,
      views: [
        { id: 1, component: 'ViewActivitiesByEntity', searchPlaceholder: 'search_by_entity' },
        { id: 2, component: 'ViewEntitiesByActivity', searchPlaceholder: 'search_by_activity' },
      ],
      activeComponent: { id: 2, component: 'ViewEntitiesByActivity', searchPlaceholder: 'search_by_activity' },
      userActivities: [],
      userActivitiesByService: {},
      querySearch: '',
      showQuerySearch: false,
      showQueryButton: true,
      searchTooltip: { content: this.$t('users.activities.search_tooltip'), placement: 'top' },
      selectedViewService: null,
      animated: false,
      error: null,
      userSubRoles: null,
      clusters: [],
      allActivities: [],
      dataset: [],
      entitiesNonRemovable: []
    }
  },
  mounted () {
    this.showQuerySearch = false
    this.loadClusters()
  },
  methods: {
    loadActivities: function (url = `${this.$store.state.evollauth_server}/activities`) {
      this.$http({ url })
        .then((response) => {
          this.allActivities = response.data.data
        }).catch((err) => {
          console.error(err)
        })
    },
    loadUserWorkActivities: function (url = `${this.$store.state.evollauth_server}/users/${this.userDetails.id}${workActivitiesEndpoint}`) {
      this.$http({
        url
      }).then(response => {
        this.userActivities = response.data.data
      })
        .catch(err => console.log(err))
        .finally(() => {
          this.isFetchingServer = false
        })
    },
    loadClusters: function (url = `${this.$store.state.evollauth_server}${authenticationServerClustersEndpoint}`) {
      this.$http({ url })
        .then((response) => {
          this.clusters = response.data.data
        }).catch(err => console.log(err))
    },
    showRolesForEntityModal: function ({ roles, entity }) {
      this.$emit('showRolesForEntityModal', { roles, entity })
    },
    showEntitiesForRoleModal: function ({ entities, role }) {
      this.$emit('showEntitiesForRoleModal', { entities, role })
    },
    showEntitiesForActivityModal: function ({ entities, activity }) {
      this.$emit('show-entities-for-activity-modal', { entities, activity })
    },
    filterUserRoles: function () {
      this.showQuerySearch = !this.showQuerySearch
      this.showQueryButton = !this.showQueryButton
      if (this.showQuerySearch) {
        Vue.nextTick(() => {
          this.$refs.inputQuerySearch.focus()
        })
      } else {
        this.querySearch = ''
      }
    },
    toogleView: function (currentViewId) {
      this.activeComponent = this.views.find(view => view.id !== currentViewId)
      this.querySearch = ''
      this.animated = true
      setTimeout(() => {
        this.animated = false
      }, 500)
      this.showQuerySearch = false
      this.showQueryButton = true
    },
    updateUserActivities: function (payload) {
      this.showLoadingIndicator = true
      this.$http({
        url: `${this.$store.state.evollauth_server}/users/${this.userDetails.id}/workactivities`,
        method: 'PATCH',
        data: payload
      }).then((response) => {
        this.userActivities = response.data.data
        this.showLoadingIndicator = false
        this.entitiesNonRemovable = response.data.entitiesNonRemovable
        if (this.entitiesNonRemovable.length) {
          this.alertNonRemovableEntities()
        } else {
          this.showToast(this.$t('users.activities.updated'), this.$store.state.successToastOptions)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    alertNonRemovableEntities: function () {
      let contentHTML = ``
      this.entitiesNonRemovable.forEach(entityId => {
        let entity = this.authenticationService.entities.find(entity => entity.id === entityId)
        contentHTML += `<li>${entity.name}`
        if (entity.cities.length) {
          contentHTML += ` (${entity.cities[0]})`
        }
        contentHTML += `</li>`
      })
      this.showToast(`
          <div>
            <h6>${this.$t('users.activities.updated')}</h6>
            ${this.$t('users.activities.non_removable_entities')}
            <ul>
              ${contentHTML}
            </ul>
          </div>
        `, this.$store.state.infoToastOptions)
      this.entitiesNonRemovable = []
    },
    resetSearch: function () {
      this.showQuerySearch = false
      setTimeout(() => {
        this.showQueryButton = true
        this.querySearch = ''
      }, 500)
    }
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    authenticationService: function () {
      return this.services.find(s => s.url === this.$store.state.evollauth_server)
    },
    limitItemsByScreenSize: function () {
      if (this.windowWidth < 768) {
        return 1
      } else if (this.windowWidth < 1024) {
        return 4
      } else if (this.windowWidth < 1280) {
        return 5
      } else {
        return 6
      }
    },
    toogleViewsTooltip: function () {
      return this.activeComponent.id === 1 ? this.$t('users.roles.switch_view_1') : this.$t('users.roles.switch_view_2')
    }
  },
  watch: {
    userDetails: {
      handler () {
        this.loadUserWorkActivities()
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
.reset-filter{
  color: #C0C0C0;
  cursor: pointer;
  background-color: white;
}

.reset-search{
  color: #29c4a9;
  position: relative;
  margin-left: -25px;
}

.searchRoles {
  border-radius:20px;
  border-color: #A49D97;
  padding-left:10px;
  border-style: solid;
  padding-right: 18px;
  width: 225px;
  -webkit-transition: all .5s ease;
  -moz-transition: all .5s ease;
  transition: all .5s ease;
}

input.searchRoles{
    outline: none;
    border-color: #29c4a9;
}

.searchRoles::-webkit-outer-spin-button,
.searchRoles::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.search-text-wrapper{
  min-height: 35px;
}

.v-leave { opacity: 1; }
.v-leave-active { transition: opacity 250ms }
.v-leave-to { opacity: 0; }
.v-enter { opacity: 0; }
.v-enter-active  { transition: opacity 250ms }
.v-enter-to { opacity: 1; }

.search-roles-gone{
  cursor: default;
  visibility: none;
  opacity: 0;
  width: 0;
  animation-name: dissapearAnimation;
  animation-duration: 650ms;
}

@keyframes dissapearAnimation {
  0% {
    width: 225px;
  }
  100% {
    width: 0px;
    display: none;
  }
}

.multiselect .multiselect__tag {
    background-color: #29c4a9;
}
.multiselect .multiselect__option--highlight {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--highlight::after {
  background-color: #29c4a9;
}

.multiselect .multiselect__option--selected {
  background-color: #d9d9d9;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight {
  background-color: #e34a4a;
}

.multiselect .multiselect__option--selected.multiselect__option--highlight::after {
  background-color: #e34a4a;
}

.animated {
  animation: spin 500ms infinite;
}

@keyframes spin {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(180deg);}
}

.modal{
  overflow: auto;
}

.vuestic-tabs .tab-content {
  padding-top: 1rem;
}
</style>
